import type { UseQueryOptions } from '@tanstack/react-query';

import { accessControlGetAccessControl } from '@repo/sdk/funcs/accessControlGetAccessControl';
import { AccessControl } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetAccessControlRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetAccessControlQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
}

export const getAccessControlQuery = ({
  agentId,
  client,
}: GetAccessControlQueryProps): UseQueryOptions<
  AccessControl[],
  SDKError,
  AccessControl[] | undefined | any
> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'accessControl'],
    queryFn: () =>
      client<GetAccessControlRequest, AccessControl[]>({
        gaiaFunc: accessControlGetAccessControl,
        request: { agentId: agentId! },
      }),
    staleTime: Infinity,
  };
};
